import { render, staticRenderFns } from "./SeoText.vue?vue&type=template&id=37cf59a8&scoped=true&"
import script from "./SeoText.vue?vue&type=script&lang=js&"
export * from "./SeoText.vue?vue&type=script&lang=js&"
import style0 from "./SeoText.vue?vue&type=style&index=0&id=37cf59a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf59a8",
  null
  
)

export default component.exports